<template>
  <v-layout row align-center justify-space-between class="transaction-item">
    <v-flex class="my-2" grow>
      <div class="font-weight-bold message my-1">{{transaction.code.extendedId}}</div>
      <div class="serial-number my-1">{{transaction.code.serialNumber}}</div>
    </v-flex>
    <v-flex class="my-2" shrink>
      <div class="status-label" :style="{color: statusMessage.color}">{{statusMessage.label}}</div>
    </v-flex>
  </v-layout>
</template>

<script>
import * as transactionUtils from '@/utils/transaction'
import { mapGetters } from 'vuex'

export default {
  name: 'TransactionItem',
  props: {
    transaction: {
      type: Object
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    statusMessage () {
      return transactionUtils.getStatusMessage(this.transaction.status)
    }
  }
}
</script>

<style lang="scss" scoped>

.circle{
  border-radius: 50%;
  background: #2a63d5;
}

.label{
  font-size: 11px;
}

.serial-number{
  font-size: 16px;
  font-weight: 600;
}

.message{
  font-size: 13px;
}

.status-label{
  font-size: 16px;
  font-family: Roboto;
  font-style: italic;
  font-weight: bold;
  margin: 0 50px;
}

</style>
